// components/Testimonials.js - Testimonials component
import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, Grid, Card, CardContent, Avatar, Rating } from '@mui/material';
import { FormatQuote as FormatQuoteIcon } from '@mui/icons-material';

const Testimonials = () => {

    const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const { testimonials } = useSelector((state) => state.testimonials);

  return (
    <Box id="testimonials" sx={{ py: 8 }}>
      <Typography
        variant="h2"
        align="center"
        sx={{ mb: 2, background: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}
      >
        What Our Clients Say
      </Typography>
      <Typography variant="h6" align="center" color="text.secondary" sx={{ mb: 6, maxWidth: 700, mx: 'auto' }}>
        Don't just take our word for it - hear from some of our satisfied clients
      </Typography>

      <Grid container spacing={4}>
        {testimonials.map((testimonial) => (
          <Grid item xs={12} md={6} key={testimonial.id}>
            <Card sx={{ height: '100%', borderRadius: 3, position: 'relative', overflow: 'hidden' }}>
              <FormatQuoteIcon
                sx={{
                  position: 'absolute',
                  top: 20,
                  right: 20,
                  fontSize: 60,
                  color: 'rgba(106, 17, 203, 0.1)',
                  transform: 'rotate(180deg)',
                }}
              />
              <CardContent sx={{ p: 4 }}>
                <Rating value={testimonial.rating} readOnly sx={{ mb: 3 }} />
                <Typography variant="body1" sx={{ mb: 4, fontStyle: 'italic', fontSize: '1.1rem' }}>
                  "{testimonial.content}"
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    sx={{
                      bgcolor: testimonial.avatarColor,
                      width: 56,
                      height: 56,
                      mr: 2,
                      fontWeight: 600,
                      fontSize: '1.2rem',
                    }}
                  >
                    {testimonial.name.charAt(0)}
                  </Avatar>
                  <Box>
                    <Typography variant="h6" component="div">
                      {testimonial.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {testimonial.role}
                      {testimonial.company && ` • ${testimonial.company}`}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Testimonials;